import { render, staticRenderFns } from "./ItemCategoryList.vue?vue&type=template&id=3be22d04&"
import script from "./ItemCategoryList.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./ItemCategoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports